import { Layout } from 'antd';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';

const { Header } = Layout;

const StyledHeader = styled(Header)`
  &&& {
    width: 100%;
    padding: 0 16px;
    z-index: 11;
    height: ${props => props.theme.layoutHeaderHeight}px;
    line-height: ${props => props.theme.layoutHeaderContentHeight}px;

    box-shadow: ${props => props.theme.boxShadowCustomLine};

    // Per evitare lo scroll non desiderato del contenuto della Pagina
    // quando l'header è più largo del browser
    overflow-x: auto;

    &.fixed-header {
      position: fixed;
    }
  }
`;

export interface IAdminHeaderTopWrapperLayoutProps {
  fixed?: boolean;
  children?: React.ReactNode;
}
/**
 * Header Base.
 */
export function AdminHeaderTopWrapperLayout(
  props: Readonly<IAdminHeaderTopWrapperLayoutProps>,
) {
  const { fixed, children } = props;

  return (
    <StyledHeader className={clx({ 'fixed-header': fixed })}>
      {children}
    </StyledHeader>
  );
}
